import {createElement, PropTypes} from 'rlink-react';
import * as services from 'rlink-shop/service/index';
import shopStore from 'rlink-shop/store';
import ShopItem from 'rlink-shop/components/connected/ShopItem';
import {List} from 'immutable';

function groupShopItems (css, shopItemsByRow, lastRow) {
  let shopItemsGrouped = [];
  let shopItemsSorted = [];
  for (let i = 0; i <= lastRow; i++) {
    if (shopItemsByRow[i]) {
      shopItemsSorted.push(shopItemsByRow[i]);
    }
  }
  shopItemsGrouped = shopItemsSorted.map(shopItemsRow => <div key={shopItemsRow[0].key}
    className={`${css.row} ${css[`fit-${shopItemsRow.length}`]}`}>{shopItemsRow}</div>);

  return shopItemsGrouped;
}

export default function ShopListing ({css, slug, userCountry, region, defaultRatingsBoard, shopItems, layoutType, skuGroups}) {

  let shopServices = {};

  let getShopService = function (type, initWith) {
    if (type) {
      if (!shopServices[type]) {
        shopServices[type] = new services[type](initWith);
      }

      return shopServices[type];
    }
  };

  let shopItemsByRow = {};
  let shopItemsData = shopItems.toJS();
  let lastRow = -1;
  for (let key in shopItemsData) {
    let shopItem = shopItemsData[key];
    let shopService = getShopService(shopItem.vendor, skuGroups);

    let itemLayoutType = (layoutType)
      ? layoutType
      : (shopItem.layoutType)
        ? shopItem.layoutType
        : undefined;
    let renderable = <ShopItem key={`${shopItem.title}${shopItem.subtitle}`}
      layoutType={itemLayoutType}
      userCountry={userCountry}
      open={shopItem.slug === slug}
      purchaseModalSize={{width: 526, height: 327}}
      css={css}
      region={region}
      defaultRatingsBoard={defaultRatingsBoard}
      service={shopService}
      productData={shopStore.getFullProductState(shopItem.identifier)}
      shopItem={shopItem} />;
    if (shopItem.row in shopItemsByRow) {
      shopItemsByRow[shopItem.row].push(renderable);
    } else {
      shopItemsByRow[shopItem.row] = [renderable];
    }

    lastRow = (shopItem.row > lastRow) ? shopItem.row : lastRow;
  }

  return (<div className={css['shop-container']}>
    {(lastRow >= 0) && groupShopItems(css, shopItemsByRow, lastRow)}
  </div>);
}
ShopListing.layoutTypes = ShopItem.layoutTypes;

ShopListing.propTypes = {
  css: PropTypes.object,
  slug: PropTypes.string,
  userCountry: PropTypes.string,
  region: PropTypes.string,
  defaultRatingsBoard: PropTypes.string,
  shopItems: PropTypes.instanceOf(List),
  layoutType: PropTypes.oneOf(Object.values(ShopListing.layoutTypes)),
  skuGroups: PropTypes.object,
};




// WEBPACK FOOTER //
// ./lib/rlink-shop/components/ShopListing.jsx